import { FormHistoryScreen, FormRecordScreen, recordPrintFooter } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Shell } from '../components/Shell.js';
import { useOfficeForms } from '../office-forms.js';
import { useOfficeDocuments } from './DocumentPages.js';

/** Compliance ▸ ISM Forms ▸ Form History: filo listesi ve gemi süzgeci (`?vessel=`). */
export function FormHistoryPage() {
  const { t } = useTranslation();
  const forms = useOfficeForms();
  const documents = useOfficeDocuments();
  return (
    <Shell title={t('menu.complianceIsmFormHistory')}>
      <FormHistoryScreen source={forms} documents={documents} />
    </Shell>
  );
}

/** Kayıt sayfası `/compliance/ism-forms/records/:id` (menüde değil; sayfa içi bağlantı). */
export function FormRecordPage() {
  const { t } = useTranslation();
  const { id = '' } = useParams();
  const forms = useOfficeForms();
  return (
    <Shell title={t('forms.record.pageTitle')}>
      <FormRecordScreen
        key={id}
        recordId={id}
        source={forms}
        printFooter={(record, printedRevisionNo) =>
          recordPrintFooter((key, options) => t(key, options ?? {}), record, forms, {
            printedRevisionNo,
          })
        }
      />
    </Shell>
  );
}
